import React from 'react';
import './About.scss';
import { TweenLite } from 'gsap';

export default class About extends React.Component {

  componentDidMount = () => {
    TweenLite.set(this.refs.self,{opacity:0})
    TweenLite.to(this.refs.self,1,{opacity:1,ease:'easeOutExpo', delay: 1})
  }

  render() {

    let {title, supertitle,copy1, copy2} = this.props
    return (
      <div className="About" ref="self">
        <header>
          <h2 className="superhead" dangerouslySetInnerHTML={{__html:supertitle}}></h2>
          <h1 dangerouslySetInnerHTML={{__html:title}}></h1>
          <p>
            {copy1}
          </p>
          <p>
            {copy2}
          </p>
        </header>
      </div>
    );
  }
}

